module.exports = __webpack_public_path__ + "img/20190614162408QQ截图20190612163047.2f588280.png";